import ContentsUploadModal from 'govbr.frontend.policy/components/ContentsUploadModal/ContentsUploadModal';

export default ContentsUploadModal;
